import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Toaster } from 'sonner';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: 'var(--nucleo-bg)' }}>
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile top bar */}
        <header
          className="flex items-center gap-3 px-4 py-3 lg:hidden"
          style={{ borderBottom: '1px solid var(--nucleo-line)', background: 'var(--nucleo-surface)' }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            className="rounded p-1.5 transition-colors"
            style={{ color: 'var(--nucleo-mute)' }}
          >
            <Menu className="h-5 w-5" />
          </button>
          <span className="text-sm font-medium tracking-tight" style={{ color: 'var(--nucleo-ink)', letterSpacing: '-0.2px' }}>Núcleo</span>
        </header>

        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
            <Outlet />
          </div>
        </main>
      </div>

      <Toaster richColors position="top-right" />
    </div>
  );
}
